import { ChevronDown } from 'lucide-react'

import { cn } from '@/utils'
import { Popover, PopoverTrigger } from '@/components/ui/popover'
import {
  FONT_SIZE_MAX,
  FONT_SIZE_MIN,
  FONT_SIZE_PRESETS,
} from '@/components/app/panels/left-panel/type-panel/type-panel-presets'

import { TRIGGER_CLASS } from '../constants/format-control-classes'
import type { ControlProps } from '../types/control-props'
import { FormatPopoverContent } from './format-popover-content'
import { NumericPresetField } from './numeric-preset-field'

export function TextOnPathFontSizeControl({
  config,
  className,
  onConfigChange,
  onRestoreFocus,
}: ControlProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" aria-label="Font size" className={cn(TRIGGER_CLASS, className)}>
          {config.fontSizePt}
          <ChevronDown className="h-4 w-4" />
        </button>
      </PopoverTrigger>
      <FormatPopoverContent className="w-[320px]" onRestoreFocus={onRestoreFocus}>
        <NumericPresetField
          label="Size"
          value={config.fontSizePt}
          min={FONT_SIZE_MIN}
          max={FONT_SIZE_MAX}
          step={1}
          presets={FONT_SIZE_PRESETS}
          presetLabel={(preset) => `${preset}pt`}
          suffix="pt"
          onCommit={(next) => onConfigChange({ fontSizePt: next })}
        />
      </FormatPopoverContent>
    </Popover>
  )
}
